export const HEAD_CELL_SX = {
  bgcolor: '#F1F3F9',
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: '0.02em',
  padding: '13px 8px',
  color: '#000000',
  borderBottom: '1px solid #D1D5DB',
};

export const ROW_CELL_SX = {
  fontSize: 14,
  padding: '10px 8px',
};

export const TABLE_CONTAINER_SX = {
  border: '1px solid #D1D5DB',
  borderRadius: '8px',
  overflow: 'hidden',
  '& tbody tr:nth-of-type(even)': { backgroundColor: '#F8F9FC' },
};
